import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { invalidateCompanySkillQueries } from './invalidateCompanySkillQueries';

export default function useDeleteTenantSkill() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId }: { skillId: string }) =>
      api.delete(`/tenant/custom-skills/${skillId}`),
    onSuccess: () => invalidateCompanySkillQueries(queryClient),
  });
}
